import React from 'react';
import styled from 'styled-components';
import moment from 'moment/moment';
import PropTypes from 'prop-types';

import useUser from 'core/hooks/useUser';
import { Box, Text } from 'core/ui/atoms';

const DeliveryDay = ({ isDefault = false }) => {
  const { currentUser } = useUser();
  const nextCutoffTime = moment(currentUser?.nextDeliveryOrderDate).format('dddd, MMMM Do');

  if (!currentUser?.nextDeliveryOrderDate) {
    return null;
  }

  if (isDefault) {
    return (
      <DefaultContainer>
        <DefaultTextBox>Your next box will be delivered</DefaultTextBox>
        <DefaultTextBox>between 8AM-8PM on {nextCutoffTime}</DefaultTextBox>
      </DefaultContainer>
    );
  }

  return (
    <Container>
      <TextBox>Your next box will be delivered</TextBox>
      <TextBox>between 8AM-8PM on {nextCutoffTime}</TextBox>
    </Container>
  );
};

DeliveryDay.propTypes = {
  isDefault: PropTypes.bool,
};

const DefaultContainer = styled(Box)`
  background: ${({ theme }) => theme.colors.primary};
  padding-top: 16px;
  padding-bottom: 16px;
  ${(p) => p.theme.max('sm')`
    width: 100%;
    display: block;
  `}
`;

const DefaultTextBox = styled(Text)`
  color: ${({ theme }) => theme.colors.creamWhite};
  font-family: ${({ theme }) => theme.typography.familyPopins};
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  padding: 12px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  ${(p) => p.theme.max('sm')`
    color: ${({ theme }) => theme.colors.creamWhite};
    font-family: ${({ theme }) => theme.typography.familyPopins};
    background: ${({ theme }) => theme.colors.primary};
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
    display: block;
    margin: 0px;
    padding-bottom: 0px;
    padding-top: 0px;
  `}
`;

const Container = styled(Box)`
  ${(p) => p.theme.max('sm')`
    background: ${({ theme }) => theme.colors.primary};
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
    display: block;
  `}
`;

const TextBox = styled(Text)`
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.typography.familyPopins};
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  padding: 12px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  ${(p) => p.theme.max('sm')`
    color: ${({ theme }) => theme.colors.creamWhite};
    font-family: ${({ theme }) => theme.typography.familyPopins};
    background: ${({ theme }) => theme.colors.primary};
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
    display: block;
    margin: 0px;
    padding-bottom: 0px;
    padding-top: 0px;
  `}
`;

export default DeliveryDay;
